import { render, staticRenderFns } from "./FormUcsis.vue?vue&type=template&id=cb9d2694"
import script from "./FormUcsis.vue?vue&type=script&lang=js"
export * from "./FormUcsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports